export const regionsSelectItems = [
  {
    value: 'NCR (National Capital Region)',
    label: 'NCR (National Capital Region)',
    code: 'NCR'
  },
  {
    value: 'CAR (Cordillera Administrative Region)',
    label: 'CAR (Cordillera Administrative Region)',
    code: 'CAR'
  },
  {
    value: 'Region I (Ilocos Region)',
    label: 'Region I (Ilocos Region)',
    code: 'I'
  },
  {
    value: 'Region II (Cagayan Valley)',
    label: 'Region II (Cagayan Valley)',
    code: 'II'
  },
  {
    value: 'Region III (Central Luzon)',
    label: 'Region III (Central Luzon)',
    code: 'III'
  },
  {
    value: 'Region IV-A (Calabarzon)',
    label: 'Region IV-A (Calabarzon)',
    code: 'IV'
  },
  {
    value: 'Mimaropa (Southwestern Tagalog Region)',
    label: 'Mimaropa (Southwestern Tagalog Region)',
    code: 'MIMAROPA'
  },
  {
    value: 'Region V (Bicol Region)',
    label: 'Region V (Bicol Region)',
    code: 'V'
  },
  {
    value: 'Region VI (Western Visayas)',
    label: 'Region VI (Western Visayas)',
    code: 'VI'
  },
  {
    value: 'Region VII (Central Visayas)',
    label: 'Region VII (Central Visayas)',
    code: 'VII'
  },
  {
    value: 'Region VIII (Eastern Visayas)',
    label: 'Region VIII (Eastern Visayas)',
    code: 'VIII'
  },
  {
    value: 'Region IX (Zamboanga Peninsula)',
    label: 'Region IX (Zamboanga Peninsula)',
    code: 'IX'
  },
  {
    value: 'Region X (Northern Mindanao)',
    label: 'Region X (Northern Mindanao)',
    code: 'X'
  },
  {
    value: 'Region XI (Davao Region)',
    label: 'Region XI (Davao Region)',
    code: 'XI'
  },
  {
    value: 'Region XII (Soccsksargen)',
    label: 'Region XII (Soccsksargen)',
    code: 'XII'
  },
  {
    value: 'Region XIII (Caraga)',
    label: 'Region XIII (Caraga)',
    code: 'XIII'
  },
  { value: 'BARMM (Bangsamoro)', label: 'BARMM (Bangsamoro)', code: 'BARMM' }
]
